export class Matrix2DInt {
    constructor(i, j) {
        this.i = i;
        this.j = j;
    }
}